/* eslint-disable @typescript-eslint/no-explicit-any */

import { CTL_GroupLabel } from "@/compo/CTL_GroupLabel";
import CTL_SVG from "@/compo/CTL_SVG";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router";
import Category from "./Category";
import axios from "axios";
import { SessionStore } from "@/store/SessionStore";
import Editor from "@/pages/_common/Editor";
import CTL_Button from "@/compo/CTL_Button";
// import { GameSetupStore, useGameSetupStore } from "@/store/GameSetupStore";

// reactQuill 커스텀 툴바
//https://velog.io/@mingle_1017/React-Quill-Editor-Custom-ToolBar%EB%A7%8C%EB%93%A4%EA%B8%B0
//https://velog.io/@hskwon517/React-Quill-%EC%97%90%EB%94%94%ED%84%B0-%EC%82%AC%EC%9A%A9%ED%95%98%EA%B8%B0

export default function LayoutGameSetup() {
  const param = useParams();
  const navi = useNavigate();
  const [gameInfo, set_gameInfo]=useState<any>(null);
  
  const [message, set_message]=useState<any>('<p></p>');
    
  // const setupStore = useGameSetupStore();

  useEffect(() => {
    // 게임정보를 가지고온다.
    const proc = async()=>{
      const { data } = await axios.post("/game/info", {
        game_code: param.game_code,
      });
      set_gameInfo( data.info );

      await SessionStore.init( {
        game_code:param.game_code,
        grade:'manager',
      } );
      // SessionStore.on("connect", (socket: Socket) => {
      //   console.log(">connect", socket.id);
      //   // SessionStore.emit("manager-connect",{ game_code: param.game_code });
      // });  
      // SessionStore.on("disconnect", (socket: Socket) => {
      //   console.log(">connect", socket.id);
      // }); 
      SessionStore.on("lastmessage", (data:any) => {
        //console.log(">lastmessage", data );
        set_message( data.msg );
      }); 
    };
    proc();
    return()=>{
      SessionStore.disconnect();
    }
    // if(param.game_code) GameSetupStore.init(param.game_code)
  }, [param.game_code]);


  if(gameInfo==null){
    return <div>loading...</div>
  }else{
    return <>
      <div className="flex flex-col">
        
        <div className="absolute right-2 flex">
          {/* 닫기버튼 */}
          <div onClick={() => navi("/admin/game-list")}>
            <CTL_SVG
              className="w-[40px] fill-amber-800/80"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </div>
        </div>
        
        <div className="px-3">
          <CTL_GroupLabel label="대회 코드">{gameInfo.game_code}</CTL_GroupLabel>
        </div>

        <div className="px-2 flex flex-col gap-1">
          <Editor
            className="flex-1"
            viewMode={false}
            html={message}
            onUpdate={(html: string) =>{
              set_message( html );
              // console.log("update subject", html);
            }}
          />
          <div className="flex gap-2">
            <CTL_Button className="bg-green-500 font-bold text-white" 
              onClick={() =>{
                SessionStore.sendMessage( message );
                // console.log("update subject", html);
              }}
            >메세지 보내기</CTL_Button>
            <CTL_Button className="bg-red-500 font-bold text-white" 
              onClick={() =>{
                set_message( '<p></p>' );
                SessionStore.sendMessage( '<p></p>' );
                // console.log("update subject", html);
              }}
            >메세지 삭제</CTL_Button>
          </div>
          
        </div>
        <Category itemList={[
          {label:'기본정보', to:`/admin/game-setup/${gameInfo.game_code}/`},
          {label:'등급관리', to:`/admin/game-setup/${gameInfo.game_code}/setup-type/`},
          {label:'신청관리', to:`/admin/game-setup/${gameInfo.game_code}/registration/`},
          {label:'경기설정', to:`/admin/game-setup/${gameInfo.game_code}/setup-race/`},
          {label:'경기진행', to:`/admin/game-setup/${gameInfo.game_code}/manage-race/`},
        ]}>  
        </Category>
        <div className="bg-white">  
          <Outlet context={{gameInfo, set_gameInfo}}/>
        </div>
    
        {/* view footer */}
        <div className="
          flex flex-col
          bg-linear-[#DDD,10%,#FFF] 
        ">
          <div className="bg-white rounded-b-[10px] w-full h-[10px]"></div>
          <div className="h-[80px]"></div>        
        </div>
      </div>
    </>;
  }
}
